import { RefObject, useState, useEffect, useCallback } from 'react';

export const useScrollEndDetection = (
  elementRef: RefObject<HTMLDivElement>,
  dependencies: any[] = [],
) => {
  const [isEndDetection, setIsEndDetection] = useState(true);

  const handleScroll = useCallback(() => {
    if (!elementRef.current) {
      return;
    }

    const { scrollTop, scrollHeight, clientHeight } = elementRef.current;

    if (scrollTop + clientHeight + 16 >= scrollHeight) {
      setIsEndDetection(true);
    } else {
      setIsEndDetection(false);
    }
  }, [elementRef, ...dependencies]);

  const scrollToBottom = () => {
    if (elementRef.current) {
      elementRef.current.scrollTop = elementRef.current.scrollHeight;
    }
  };

  useEffect(() => {
    handleScroll();

    const el = elementRef.current;
    if (!el) {
      return;
    }

    el.addEventListener('scroll', handleScroll);
    window.addEventListener('resize', handleScroll);
    window.visualViewport?.addEventListener('resize', handleScroll);

    return () => {
      el.removeEventListener('scroll', handleScroll);
      window.removeEventListener('resize', handleScroll);
      window.visualViewport?.removeEventListener('resize', handleScroll);
    };
  }, [elementRef, handleScroll]);

  return { isEndDetection, handleScroll, scrollToBottom };
};
